import { observable } from 'mobx';
import { getFisOrBopisFeatureFlagStatus } from '../../utils';
import { checkStoreAvailability, IFindInStoreState } from './findInStoresUtils';
import { setStoreLocatorSidebarIsLoadingState } from '../StoreLocator/storeLocatorSidebarState';

const { isBopisEnabled, isFisEnabled } = getFisOrBopisFeatureFlagStatus();
// Priority: if both enabled for specific country, always set fis as false.
export const findInStoreState = observable<IFindInStoreState>({
  enabled: isFisEnabled && !isBopisEnabled,
  storesData: null,
  storesDataError: null,
  async fetchStoresData(sku: string) {
    const findInStoreInputs = {
      sku: sku,
      limit: 10,
    };
    setStoreLocatorSidebarIsLoadingState(true);
    const response = await checkStoreAvailability(findInStoreInputs);
    setStoreLocatorSidebarIsLoadingState(false);
    if ('detail' in response) {
      if (response.detail.toLowerCase() === 'location is unknown') return;
      this.storesDataError = response;
    } else {
      if (this.storesDataError) this.storesDataError = null;
      this.storesData = response;
    }
  },
});
